import {
  compose,
  withAuthorized,
  withSuperAdminLayout,
  withHelmet
} from '../../core';
import { SuperAdminCompaniesContainer } from '../../features/super-admin-companies/SuperAdminCompaniesContainer';

export const SuperAdminCompaniesPage = compose(
  withAuthorized,
  withSuperAdminLayout,
  withHelmet({
    title: 'Splashworks: Super Admin Companies'
  })
)(SuperAdminCompaniesContainer);
